/**
 * Chat component constants and configuration
 */

export const CHAT_CONSTANTS = {
  CONTEXT_WINDOW_SIZE: 20,
  AUTO_SCROLL_DELAY: 100,
  DEBOUNCE_DELAY: 500,
  PREVIEW_MAX_ENRICHMENTS: 6,
} as const;

/**
 * Chat UI text constants
 */
export const CHAT_TEXT = {
  BRAND_NAME: 'Skylarq',
  BRAND_NAME_UPPER: 'SKYLARQ',
  SUBTITLE: 'AI Assistant',
  PLACEHOLDER: 'Ask Skylarq...',
  PLACEHOLDER_FULL: 'Ask Skylarq anything...',
  EMPTY_STATE_TITLE: 'How can I help?',
  EMPTY_STATE_DESCRIPTION: 'Ask me to find more leads, enrich your data, analyze patterns, or start a campaign.',
  THINKING: 'Thinking...',
  ERROR_MESSAGE: 'I apologize, but I encountered an error processing your request. Please try again.',
} as const;

export const ACTION_TYPES = {
  PREVIEW_DATASET: 'preview_dataset',
  GENERATE_DATASET: 'generate_dataset',
  FIND_MORE_RESULTS: 'find_more_results',
  ENRICH_COLUMN: 'enrich_column',
  SEND_EMAILS: 'send_emails',
  // Monitor actions
  CREATE_MONITOR: 'create_monitor',
  CREATE_MONITOR_WITH_DATASET: 'create_monitor_with_dataset',
  LIST_MONITORS: 'list_monitors',
  UPDATE_MONITOR: 'update_monitor',
  DELETE_MONITOR: 'delete_monitor',
  LIST_MONITOR_RUNS: 'list_monitor_runs',
  NONE: 'none'
};

export const CHAT_ROLES = {
  USER: 'user',
  ASSISTANT: 'assistant'
} as const;

export const AVAILABLE_ACTIONS = {
  DATASET_ACTIONS: [ACTION_TYPES.PREVIEW_DATASET, ACTION_TYPES.GENERATE_DATASET],
  TABLE_ACTIONS: [ACTION_TYPES.FIND_MORE_RESULTS, ACTION_TYPES.ENRICH_COLUMN, ACTION_TYPES.SEND_EMAILS],
  // Monitor actions available when on a dataset (create_monitor requires existing dataset)
  MONITOR_ACTIONS_WITH_DATASET: [
    ACTION_TYPES.CREATE_MONITOR,
    ACTION_TYPES.LIST_MONITORS,
    ACTION_TYPES.UPDATE_MONITOR,
    ACTION_TYPES.DELETE_MONITOR,
    ACTION_TYPES.LIST_MONITOR_RUNS
  ],
  // Monitor actions available without a dataset
  MONITOR_ACTIONS_NO_DATASET: [
    ACTION_TYPES.CREATE_MONITOR_WITH_DATASET,
    ACTION_TYPES.LIST_MONITORS
  ]
};

